import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=8733216c&scoped=true"
import script from "./CompanyProfile.vue?vue&type=script&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=8733216c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8733216c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CompanyProfileItem: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/CompanyProfileItem.vue').default,Section: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Section.vue').default})
